import { createFileRoute } from "@tanstack/react-router";
import type { ColumnDef } from "@tanstack/react-table";

import { QueryBuilderContext } from "@/contexts/query-builder-context";
import { useTableQueryBuilder } from "@/hooks/use-table-query-builder";
import { ScreenContent, ScreenHeader, ScreenTitle, SinglePageTable } from "@/ui";

const columns: ColumnDef<{ id: string; name: string }>[] = [
  { id: "name", accessorKey: "name", enableSorting: false },
];

const IntegrationsPage = () => {
  const { queryBuilder, setSorting, sortingState } = useTableQueryBuilder({ filterKeys: [] });

  return (
    <QueryBuilderContext.Provider value={{ builder: queryBuilder }}>
      <ScreenHeader>
        <ScreenTitle>Integrations</ScreenTitle>
      </ScreenHeader>

      <ScreenContent>
        <SinglePageTable
          columns={columns}
          data={[
            { id: "bayesia", name: "Bayesia" },
            { id: "open-ai", name: "OpenAI" },
            { id: "personify", name: "Personify" },
          ]}
          isLoadingData={false}
          rowLink={({ id }) => {
            return { to: `/integrations/${id}` };
          }}
          rowsPerPage={10}
          setSorting={setSorting}
          sorting={sortingState}
        />
      </ScreenContent>
    </QueryBuilderContext.Provider>
  );
};

export const Route = createFileRoute("/_private/integrations/")({
  component: IntegrationsPage,
});
